/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap'
import { ColumnChooser, ColumnDirective, ColumnsDirective, CommandColumn, Edit, Filter, GridComponent, Group, Inject, Page, Sort, Toolbar, Selection } from '@syncfusion/ej2-react-grids'
import TabellaWareHouseSecondaria from './TabellaWareHouseSecondaria'
import toast from 'react-hot-toast'
import Swal from 'sweetalert2'

const TestTabella = (props) => {
    const { id, idMagazzino, trasmettiProdotti, tipoMovimento } = props
    const [canvasPlacement, setCanvasPlacement] = useState('start')
    const [canvasOpen, setCanvasOpen] = useState(false)
    const [prodottiDaSpostare, setprodottiDaSpostare] = useState()
    useEffect(() => {
        setprodottiDaSpostare([])
    }, [])


    // PARTE DI CODICE LEGATA ALLA GRIGLIA DEI PRODOTTI UNIFICATI.
    let grid
    let prodotti = []
    const constructor = {
        editOptions: { allowEditing: true, allowDeleting: true },
        commands:
            [
                {
                    type: 'Edit',
                    id: 'edit',
                    buttonOption: {
                        iconCss: 'e-icons e-edit',
                        cssClass: 'e-flat'
                    }
                },
                {
                    type: 'Cancel',
                    id: 'cancel',
                    buttonOption: {
                        iconCss: 'e-icons e-cancel-icon',
                        cssClass: 'e-flat'
                    }
                },
                {
                    type: 'Save',
                    id: 'save',
                    buttonOption: {
                        iconCss: 'e-icons e-save',
                        cssClass: 'e-flat'
                    }
                },

                {
                    type: 'Elimina',
                    id: 'EliminaSingolo',
                    target: '.e-column',
                    buttonOption: {
                        iconCss: 'e-icons e-trash',
                        cssClass: 'e-flat'
                    }
                }
            ]
    }
    const toolbarCustomItem = [
        { text: 'Elimina', tooltipText: 'Elimina', prefixIcon: 'e-delete', id: 'Elimina' },
        { text: 'Aggiungi', tooltipText: 'Aggiungi', prefixIcon: 'e-plus', id: 'aggiungiProdotto' },
        { text: 'Print' },
        'ColumnChooser',
        { text: 'Search' }
    ]
    const pullData = (data) => {
        setprodottiDaSpostare(data)
        toggleCanvasEnd()
        if (grid) {
            grid.refresh()
        }
    }
    const customButton = (args) => {
        if (args.commandColumn.id === 'EliminaSingolo') eliminaSingolo(args.rowData.id)
        else if (args.commandColumn.id === 'Modifica') modifica()
    }
    const eliminaSingolo = (id) => {
        prodottiDaSpostare.map((e, i) => {
            if (e.id === id) {
                prodottiDaSpostare.splice(i, 1)
                grid.refresh()
            }
        })
    }


    const toggleCanvasEnd = () => {
        setCanvasPlacement('end')
        setCanvasOpen(!canvasOpen)
    }
    const customCompleteOptions = (args) => {
        if (tipoMovimento === 'SPOSTA' || tipoMovimento === 'SCARICO') {
            if (args.requestType === 'save') {
                if (args.data.qnt > args.data.quantita) {
                    Swal.fire({
                        title: 'Sei Sicuro?',
                        text: 'La quantità che vuoi spostare è superiore alla quantità disponibile nel magazzino',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Ok',
                        cancelButtonText: 'Annulla',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                            cancelButton: 'btn btn-outline-danger ml-1'
                        },
                        buttonsStyling: false
                    })
                }
            }
        }
    }
    const customBeginOptions = (args) => {
        if (args.requestType === 'save') {
            prodotti = {
                id: args.data.id,
                quantita: args.data.qnt,
                prezzo: args.data.costo,
                iva: args.data.aliquotaIva
            }
            trasmettiProdotti(prodotti)
        }
    }
    const deleteRecords = () => {
        let recordSelezionati
        recordSelezionati = grid.getSelectedRecords()
        recordSelezionati.forEach(e => grid.deleteRecord('id', e))
    }
    // BUTTONS AZIONI DELLA TOOLBAR 
    const clickHandler = (args) => {
        if (args.item.id === 'Elimina') deleteRecords()
        if (args.item.id === 'aggiungiProdotto') {
            idMagazzino ? toggleCanvasEnd() : toast.error('Attenzione, non hai selezionato nessun magazzino', {
                position: "top-right",
                duration: 3000,
                style: {
                    background: 'red',
                    color: 'white'
                }
            })
        }
    }


    return (

        <GridComponent
            rowHeight={26}
            allowPaging={false}
            dataSource={prodottiDaSpostare}
            selectionSettings={{ checkboxMode: 'ResetOnRowClick', enableToggle: true, checkboxOnly: true }} allowSelection={true} allowFiltering={true} showColumnChooser={true} toolbar={toolbarCustomItem} filterSettings={{ type: "Menu" }}
            allowSorting={true}
            editSettings=
            {{
                allowEditing: true,
                allowDeleting: true
            }}
            ref={g => (grid = g)}
            toolbarClick={clickHandler}
            commandClick={customButton}
            actionBegin={customBeginOptions}
            actionComplete={customCompleteOptions}
        >
            <>
                <Offcanvas style={{ width: '1200px' }} direction={canvasPlacement} isOpen={canvasOpen} toggle={toggleCanvasEnd}>
                    <OffcanvasHeader toggle={toggleCanvasEnd}>Aggiungi prodotto </OffcanvasHeader>
                    <OffcanvasBody
                        className='my-auto mx-0'>
                        <TabellaWareHouseSecondaria value={prodottiDaSpostare} idProdotto={id} idMagazzino={idMagazzino} pullData={(data) => pullData(data)} ></TabellaWareHouseSecondaria>
                    </OffcanvasBody>
                </Offcanvas>
            </>

            <ColumnsDirective>
                <ColumnDirective type='checkbox' width='30' />
                <ColumnDirective field='azioni' width='70' textAlign="left" showInColumnChooser={false} allowFiltering={false} commands={constructor.commands} displayHtmlEncode={false} />
                <ColumnDirective field='id' width='30' visible={false} isPrimaryKey={true} />
                <ColumnDirective field='codice' width='100' allowEditing={false} />
                <ColumnDirective field='nome' width='200' allowEditing={false} textAlign="center" clipMode='EllipsisWithTooltip' />
                <ColumnDirective field='qnt' width='100' format="" validationRules={{ required: [true, 'Inserisci un valore'], number: true, }} textAlign="center" />
                <ColumnDirective field='quantita' width='100' allowEditing={false} format="" textAlign="center" />
                <ColumnDirective field='prezzoVendita' allowEditing={false} visible={false} width='100' headerText='prezzo' />
                <ColumnDirective field='costo' allowEditing={false} visible={false} width='100' />
            </ColumnsDirective>
            <Inject services={[Page, Sort, Filter, Group, CommandColumn, Edit, Toolbar, ColumnChooser, Selection]} />
        </GridComponent>
    )
}

export default TestTabella